import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'sc-toggle',
  styleUrls: ['./toggle.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass],
  template: `
    <div
      class="toggle-container"
      tabindex="0"
      role="switch"
      [attr.aria-checked]="value"
    >
      <div class="option" [ngClass]="{ selected: !value }">
        {{ offLabel }}
      </div>
      <div class="option" [ngClass]="{ selected: value }">
        {{ onLabel }}
      </div>
    </div>
  `,
})
export class ToggleComponent {
  @Input() value: boolean;
  @Input() onLabel: string;
  @Input() offLabel: string;

  @Output() valueChange = new EventEmitter<boolean>();

  @HostListener('keydown.enter', ['$event'])
  @HostListener('keydown.space', ['$event'])
  @HostListener('click', ['$event'])
  onClick(e) {
    this.value = !this.value;
    this.valueChange.emit(this.value);
  }
}
